import axios, { AxiosRequestConfig } from 'axios';
import { REPORTS_CONFIGS } from '../components/reports/compliance/SG/SGReportsConstant';
import ApiConstants from '../constants/ApiConstants';
import http from "../http";
import { getTenantCountryCode } from '../managers/common/CommonUtil';
import { TENANT, TenantService } from '../managers/TenantManagerService';
export interface apiConstInterface  {
    format:string,
    fromDate?:string,
    toDate?:string,
    exportAll? :string,
    selectedEmployee? :string
}
class ReportService {
    static apiConfig:apiConstInterface ;
    static exportPayrollSummaryReport(parameters) {
        let tenantData = TenantService.getData();
        const countryCode = tenantData[TENANT.COUNTRY_CODE]

        // let url = 'https://api-dev.deskera.xyz/v1/exim/payroll-summary/export/IN?format=XLSX&fromDate=2021-11-01&toDate=2021-11-30&exportAll=true&selectedEmployee='

        let url = ApiConstants.URL.IMPORT_EXPORT.EXIM + '/payroll-summary/export/' + countryCode
        let paramStr = '';
        let keys = Object.keys(this.apiConfig);
        keys.forEach((key,index)=>{
            if(index == 0) {
                paramStr = `?${[key]}=${this.apiConfig[key]}`
            } else {
                paramStr = paramStr + `&${[key]}=${this.apiConfig[key]}`
            }

        })

        const config: AxiosRequestConfig = {
            params: parameters,
            responseType: "blob"
        }
        url = url + paramStr

        return http.get(
          url,
          config
        );
      }
      static exportLiabilityReport(parameters){
        let url = ApiConstants.URL.IMPORT_EXPORT.EXIM + '/report/liability/export';
        let paramStr = '';
        let keys = Object.keys(this.apiConfig);
        keys.forEach((key,index)=>{
            if(index == 0) {
                paramStr = `?${[key]}=${this.apiConfig[key]}`
            } else {
                paramStr = paramStr + `&${[key]}=${this.apiConfig[key]}`
            }

        })

        const config: AxiosRequestConfig = {
            params: parameters,
            responseType: "blob"
        }
        url = url + paramStr

        return http.get(
          url,
          config
        );
      }
      static downloadForm(userId,form,params){
          let url = ApiConstants.URL.IMPORT_EXPORT.COMPLIANCE(userId[0],form);
          const config: AxiosRequestConfig = {

            responseType: "blob"
          }
          if(params) {
            let paramStr = '';
            let keys = Object.keys(this.apiConfig);
            keys.forEach((key,index)=>{
                if(index == 0) {
                    paramStr = `?${[key]}=${this.apiConfig[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${this.apiConfig[key]}`
                }

            })
            url = url + paramStr
          }

          return http.get(
            url,
            config
          );
      }
      static getDemoPayslip() {
          let url = 'v1/template/print-info/print-design-doc-by-uid/923d116c-9ba2-4fb9-98c1-e3aa5d0ab97c';
          // let url = 'https://mobile-erp.s3.ap-southeast-1.amazonaws.com/payslips/72132/60384/1637523768369_AMit-GUnjal.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20211129T085458Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=AKIAUCGSX5JH2PF7YG4R%2F20211129%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=a6be9ff62656cfb94b00eddc85ae1d9d317ffe5b8a1364fdb31b9d13e1ad959d'
          const config: AxiosRequestConfig = {

            responseType: "blob"
          }
          return http.get(
            url,
            config
          );
      }

      static downloadStateForm(formType,params){
          let url = ApiConstants.URL.COMPLIANCE.US.DOWNLOAD_US_STATE_FORM(formType);
          const config: AxiosRequestConfig = {

            responseType: "blob"
          }
          if(params) {
            let paramStr = '';
            let keys = Object.keys(params);
            keys.forEach((key,index)=>{
                if(index == 0) {
                    paramStr = `?${[key]}=${params[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${params[key]}`
                }

            })
            url = url + paramStr
          }

          return http.get(
            url,
            config
          );
      }

  static exportStatutoryReport(parameters) {


    let url = `${ApiConstants.URL.COMPLIANCE.BASE}/export/statutory-form?month=${parameters.month}&year=${parameters.year}&form-type=${parameters.form}`
    return http.post(url, parameters.employeeId).catch(
      (error) => {
        console.error('Error while exporting statutory report : ', error);
        return Promise.reject(error);
      }
    );
  }

  static getStatutoryReport(parameters) {
    const config: AxiosRequestConfig = {
      params: parameters,
      responseType: "blob",
    };
    let url = `${ApiConstants.URL.REPORT.STATUTORY_REPORT(getTenantCountryCode())}`;
    return http.get(url, config).catch((error) => {
      console.error("Error while exporting statutory report : ", error);
      return Promise.reject(error);
    });
  }
  static getCPFAAccounts(param) {
    const url = ApiConstants.URL.EMPLOYEE.GET_CPF_ACCOUNTS;
    return http.get(
      `${url}`, { params: param }
    );
  }
  static getUsers() {
    const url = ApiConstants.URL.PAYROLL.GET_USERS;
    return http.get(
      `${url}`
    );
  }
  
  static getFormConfig(reportName) {
    const reportConfig = {};
        if(reportName) {
            return REPORTS_CONFIGS[reportName];
        }
        return reportConfig;
  }
  static getComponentReport(parameters) {
    const config: AxiosRequestConfig = {
      params: parameters,
      responseType: "blob",
    };
    let url = `${ApiConstants.URL.REPORT.COMPLIANCE}`;
    return http.get(url, config).catch((error) => {
      console.error("Error while exporting statutory report : ", error);
      return Promise.reject(error);
    });
  }
  static getComponentGenerateReport(parameters) {
    const config: AxiosRequestConfig = {
      params: parameters
    };
    let url = `${ApiConstants.URL.REPORT.COMPLIANCE_REPORT(getTenantCountryCode())}`;
    return http.get(url, config).catch((error) => {
      console.error("Error while exporting statutory report : ", error);
      return Promise.reject(error);
    });
  }

  static downloadCpfReport(parameters) {
    return axios.create().request({
        withCredentials: true,
        baseURL: ApiConstants.URL.BASE,
        method: "GET",
        url: `${ApiConstants.URL.REPORT.CPF.DOWNLOAD_CPF_REPORT}?month=${parameters.month}&year=${parameters.year}&cpfAccount=${parameters.cpfAccount}`,
        responseType: "blob"
    });

  }

  static downloadReport(parameters, userId, reportType) {
    return axios.create().request({
        withCredentials: true,
        baseURL: ApiConstants.URL.BASE,
        method: "GET",
        url: `${ApiConstants.URL.REPORT.IRAS.DOWNLOAD_REPORT(userId, reportType)}?year=${parameters.year}&cpfAccountId=${parameters.cpfAccount}`,
        responseType: "blob"
    });

  }

  static downloadIRASESubmissionReport(parameters) {
    return axios.create().request({
        withCredentials: true,
        baseURL: ApiConstants.URL.BASE,
        method: "POST",
        url: `${ApiConstants.URL.REPORT.IRAS.IRAS_E_SUBMISSION}?formType=${parameters.formType}&year=${parameters.year}&cpfAccountId=${parameters.cpfAccount}&authorizedUserId=${parameters.authorizedUserId}`,
        responseType: "blob",
        data: parameters
    });
  }
  static getIRASFormData(param, userId) {
    const URL = ApiConstants.URL.REPORT.APPENDIX_8A.GET(userId);
    return http.get(URL,{params:param})
  }
  static saveAppendix8A(param) {
    const URL = ApiConstants.URL.REPORT.APPENDIX_8A.SAVE;
    return http.put(URL,param)
  }
  static getIR8SForm(param, userId) {
    const URL = ApiConstants.URL.REPORT.IR8S.GET(userId);
    return http.get(URL,{params:param})
  }
  static saveIR8S(param) {
    const URL = `${ApiConstants.URL.REPORT.IR8S.SAVE}?formType=IR8S`;
    return http.put(URL,param)
  }
  static downloadWageRegister(parameters) {
    const config: AxiosRequestConfig = {
      responseType: "blob",
    };
    let url = `${ApiConstants.URL.REPORT.WAGE_REGISTER.GET(parameters.month,parameters.year)}`;
    return http.get(url, config).catch((error) => {
      console.error("Error while downloading wage report : ", error);
      return Promise.reject(error);
    });
  }
  static downloadTDS(parameters) {
    const config: AxiosRequestConfig = {
      responseType: "blob",
    };
    let url = `${ApiConstants.URL.REPORT.TDS.GET(parameters.userId, parameters.month, parameters.year )}`;
    return http.get(url, config).catch((error) => {
      console.error("Error while download TDS report : ", error);
      return Promise.reject(error);
    });
  }
  static getForm16Users(params,year) {
    const URL = ApiConstants.URL.REPORT.FORM16.USERS(year);
    return http.get(URL,{params:params})
  }
  static generateForm16(parameters,year,formType) {
    const URL = ApiConstants.URL.REPORT.FORM16.GENERATE(year,formType);
    return http.post(URL, parameters).catch((error) => {
      console.error("Error while exporting Form 16  : ", error);
      return Promise.reject(error);
    });
  }
}

export default ReportService;
